import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Config } from '../../../../config';
import { AppointmentsService } from '../../../appointments/appointments.service';

@Component({
    selector: 'app-media-library',
    templateUrl: './media-library.component.html',
    styleUrls: ['./media-library.component.scss']
})

export class MediaLibraryComponent implements OnInit {
    @Output() changeValue = new EventEmitter();
    @Input() appointmentTypeId:any;
    public mediaLibraryUrl: string = "";
    public config = new Config();

    constructor(private appointmentService : AppointmentsService){}

    ngOnInit() {
        let self=this;
        // get user info
        if (window.addEventListener) {
            window.addEventListener("message", onMessage, false);        
        } 

        function onMessage(event) {
            // Check sender origin to be trusted
            if (event.origin == self.config.mediaLibraryUrl){
              let data = event.data;
              if(data){
                self.changeValue.emit(data);
              }
            }
        }

        this.openMediaPopup();

    }

    openMediaPopup(){
        let companyCode = this.appointmentService.getCookie('clientCode');
        let relationFilters:any =[{
            "relationType": "appointment",
            "relationItemId": this.appointmentTypeId ? this.appointmentTypeId.toString() : ''
          },
          {
            "relationType": "elementType",
            "relationItemId": "logo"
          }
        ];
          let r_filters = JSON.stringify(relationFilters);
        this.mediaLibraryUrl = `${this.config.mediaLibraryUrl}/openMediaPopup?r_filters=${r_filters}&clientcode=${companyCode}`;
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/components/media-library/media-library.component.ts